import * as React from 'react';
import { DropdownTabbed } from '../';
import {
  IProperty, IControlType, IAdjustmentChanges, EPropertyTypes, DOMHelper, PropertyHelper, IDropdownOptionDictionary, IConditionConfig,
  EOutputLookupContext,
  EConfirmationOperationType,
  getEntityOptionSetFromService,
  getEntityStateCodeFromService,
  getStatusReasonFromService,
  EModalType,
  ControlHelper,
  ComponentHelper,
  IFieldConfig,
  IOutput,
  IdHelper,
  EOutputScope
} from '../../helpers';
import { DayPickerStrings, HOURS, MINUTES, VISIBILITY_EXPRESSION_PROPERTY_NAME, PROPERTIES_OUTPUTS_DEBOUNCE_NUMBER } from '../../constants';
import { ContentEditableTinyMCE, QueryBuilder, CheckboxList } from '../';
import { TextField, Toggle, IDropdownOption, DatePicker, Slider, Label, Spinner, SpinnerType } from 'office-ui-fabric-react';
import { Promise } from 'es6-promise';
import store from '../../store/store';
import Select from 'react-select';
import types from '../../store/types';
import { ViewFilterQueryBuilder } from '../view-filter-query-builder/view-filter-query-builder';

declare var jQuery;

interface IProps {
  properties: IProperty[];
  primaryOnly: boolean;
  isLoading?: boolean;
  areEntityFormsLoading?: boolean;
  areEntityViewsLoading?: boolean;
  componentId: string;
  formId?: string;
  formControlId?: string;
  controlType?: IControlType;
  fields?: IFieldConfig[];
  outputOptions?: IDropdownOption[];
  entityOptionSet?: IDropdownOption[];
  entityViews?: IDropdownOption[];
  entityForms?: IDropdownOption[];
  entityFormattedAttributes?: { [id: string]: string; };
  entityViewColumns?: any[];
  entityStateCode?: IDropdownOption[];
  statusReason?: IDropdownOption[];
  dropdownChange?: (item: any) => void;
  startTabIndex?: number;
  layoutPanelIndex?: number;
  useDefaults?: boolean;
  showOnlyVisibility?: boolean;
  isLayoutPanel?: boolean;
  filteredValueOptions?: IDropdownOptionDictionary;
  propertiesToExclude?: string[];
  change: (Name: string, Value: any, componentId: string, layoutPanelIndex?: number) => void;
  updateFormField?: (formId: string, controlId: string, propertyName: string, value: any) => void;
  changeEntity?: (Name: string, Value: any, componentId: string) => void;
  updateGetRecordEntityProperty?: (Name: string, Value: any, componentId: string) => void;
  changeEntityForm?: (Name: string, Value: any, componentId: string) => void;
  changeEntityView?: (Name: string, Value: any, componentId: string) => void;
  changeEntityViewColumn?: (key: string, value?: any) => void;
  entityChange?: (item: IDropdownOption) => void;
  changeFormFields?: (Name: string, Value: any, componentId: string) => void;

};

export class Properties extends React.Component<IProps, any> {

  private firstUpdate: boolean = true;
  public entityName: string;
  private static multilineDynamicProperties: { [propertyName: string]: boolean } = {
    "Fetch XML": true
  };

  private debouncedPromise;

  constructor(props: IProps) {
    super(props);
    this.debouncedPromise = null;
    this.state = {
      dropdownSourceValue: null
    }
    this.changeDropdownSourceValue = this.changeDropdownSourceValue.bind(this);
  }

  // make necessary API calls on dropdown value change and set the response to the state.
  changeDropdownSourceValue(dropdownSourceValue: string) {

    let actionState = store.getState().modalState.actionConfig;

    var promise = new Promise((resolve, reject) => {

      getEntityOptionSetFromService(dropdownSourceValue).then(
        (response: any) => {
          let optionSet = [];
          Object.keys(response).map((val, index) => {
            optionSet.push(
              {
                key: val,
                text: response[val]
              }
            );
          });
          store.dispatch({
            type: types.ADD_ENTITY_OPTION_SET,
            entityOptionSet: optionSet
          });
          resolve(optionSet);
        },
        (error) => {
          reject(error);
        }
      );

    });

    let { properties } = this.props;
    let isStateCodePresent = properties.filter(x => x.Name === 'State Code');
    let isStatusReasonPresent = properties.filter(x => x.Name === 'Status Reason');

    // if State Code property is present, fetch state code for the selected entity and set the value of the property to null.
    if (isStateCodePresent.length) {

      var promise = new Promise((resolve, reject) => {

        getEntityStateCodeFromService(dropdownSourceValue).then(
          (response: any) => {
            let optionSet = [];
            Object.keys(response).map((val, index) => {
              optionSet.push(
                {
                  key: val,
                  text: response[val]
                }
              );
            });
            store.dispatch({
              type: types.ADD_ENTITY_STATE_CODE,
              entityStateCode: optionSet
            });
            resolve(optionSet);
          },
          (error) => {
            reject(error);
          }
        );

      });

      store.getState().modalState.actionConfig.action.Properties.filter(x => x.Name === 'State Code')[0].Value = null;
    }

    // if Status Reason property is present, fetch status reason for the selected entity and set the value of the property to null.
    // all status reasons are fetched, regardless of what state code is selected. 
    // (we might want to fetch only the related status reasons for a given state code.)
    if (isStatusReasonPresent.length) {

      var promise = new Promise((resolve, reject) => {

        getStatusReasonFromService(dropdownSourceValue, dropdownSourceValue).then(
          (response: any) => {
            let optionSet = [];
            Object.keys(response).map((val, index) => {
              optionSet.push(
                {
                  key: val,
                  text: response[val]
                }
              );
            });
            store.dispatch({
              type: types.ADD_STATUS_REASON_SET,
              statusReason: optionSet
            });
            resolve(optionSet);
          },
          (error) => {
            reject(error);
          }
        );

      });

      store.getState().modalState.actionConfig.action.Properties.filter(x => x.Name === 'Status Reason')[0].Value = null;
    }
  }


  changeStatusReasonValue(dropdownSourceValue: string) {
    let actionState = store.getState().modalState.actionConfig;

    var promise = new Promise((resolve, reject) => {

      getStatusReasonFromService(this.entityName, dropdownSourceValue).then(
        (response: any) => {
          let optionSet = [];
          Object.keys(response).map((val, index) => {
            optionSet.push(
              {
                key: val,
                text: response[val]
              }
            );
          });
          store.dispatch({
            type: types.ADD_STATUS_REASON_SET,
            statusReason: optionSet
          });
          resolve(optionSet);
        },
        (error) => {
          reject(error);
        }
      );

    });
  }

  private inputTimeout;

  private debounceValue = (name: string, value: any, componentId: string, isQuickCreateProperty: boolean = false) => {

    if (this.inputTimeout) {
      clearTimeout(this.inputTimeout);
    }
    const currentValue = value; // Store the current value

    this.inputTimeout = setTimeout(() => {
      let state = store.getState().modalState.controlConfig;
      let actionState = store.getState().modalState.actionConfig;

      if (store.getState().modalState.modal.openModal === EModalType.ActionConfig) {
        // if the action is get records and the changed property is entity name
        if (store.getState().modalState.modal.openModal === EModalType.ActionConfig &&
          actionState.action.ActionType.NameType === "Get Records") {
          if (name.toLowerCase() === 'entity name') {
            this.props.changeEntityView(name, currentValue, componentId);
            this.props.changeEntity('Views', null, componentId);
            store.getState().modalState.actionConfig.action.Properties.filter(x => x.Name === "Fetch XML")[0].IsRequired = false;
            store.getState().modalState.actionConfig.action.Properties.filter(x => x.Name === "Entity Name")[0].IsRequired = true;
            store.getState().modalState.actionConfig.action.Properties.filter(x => x.Name === "Views")[0].IsRequired = true;
          } else if (name.toLowerCase() === 'views') {
            this.props.changeEntity(name, currentValue, componentId);
          }
        }

        // if the action is create record or update record
        if (name.toLowerCase() === 'entity name' &&
          (actionState.action.ActionType.NameType === "Create Record" ||
            actionState.action.ActionType.NameType === "Update Record")
        ) {
          let fieldConfigsWithValues = store.getState().modalState.actionConfig.fieldConfigs ? store.getState().modalState.actionConfig.fieldConfigs.filter((val) =>
            val.FieldValue.length && JSON.parse(val.FieldValue).text
          ) : {};

          if (actionState.isFieldChanged || fieldConfigsWithValues.length) {
            store.dispatch({
              type: types.TOGGLE_CONFIRMATION_DIALOG,
              operationType: EConfirmationOperationType.ChangeEntity,
              title: 'Confirm Entity Change',
              message: 'Unsaved changes will be lost. Are you sure you want to change the entity?',
              isOpen: true,
              okButtonLabel: 'Proceed',
              cancelButtonLabel: 'Cancel',
              actionType: name,
              actionEntity: currentValue,
              outputs: state.control.OutputValues
            });

          } else {
            this.props.changeEntity(name, currentValue, componentId)
          }
        }

        // if the action is get record
        else if (store.getState().modalState.modal.openModal === EModalType.ActionConfig &&
          actionState.action.ActionType.NameType === "Get Record") {
          store.dispatch({
            type: types.SET_ACTION_OUTPUT_ARRAY,
            outputs: null
          });
          let fieldConfigsWithValues = store.getState().modalState.actionConfig.fieldConfigs ? store.getState().modalState.actionConfig.fieldConfigs.filter((val) =>
            val.FieldValue.length && JSON.parse(val.FieldValue).text
          ) : {};

          if (actionState.isFieldChanged || fieldConfigsWithValues.length) {
            store.dispatch({
              type: types.TOGGLE_CONFIRMATION_DIALOG,
              operationType: EConfirmationOperationType.ChangeEntity,
              title: 'Confirm Entity Change',
              message: 'Unsaved changes will be lost. Are you sure you want to change the entity?',
              isOpen: true,
              okButtonLabel: 'Proceed',
              cancelButtonLabel: 'Cancel',
              actionType: name,
              actionEntity: currentValue,
              outputs: state.control.OutputValues
            });

          } else {
            this.props.updateGetRecordEntityProperty(name, currentValue, componentId)
          }

        }
        else {
          // this.inputTimeout = setTimeout(() => {
          this.props.isLayoutPanel ?
            this.props.change(name, currentValue, componentId, this.props.layoutPanelIndex)
            :
            this.props.change(name, currentValue, componentId);
          // }, 500);
        }
      }

      // if the opened modal is a block component
      else if (store.getState().modalState.modal.openModal === EModalType.ControlConfig) {

        if (store.getState().modalState.controlConfig.control.ControlType.NameType === "Create Form") {

          if (name.toLowerCase() === 'entity name') {
            this.props.changeEntityForm(name, currentValue, componentId);
          } else if (name.toLowerCase() === 'views') {
            this.props.changeEntity(name, currentValue, componentId);
          }

        }
        else if (store.getState().modalState.controlConfig.control.ControlType.NameType === "Get View" ||
          store.getState().modalState.controlConfig.control.ControlType.NameType === "Datatable") {
          if (name.toLowerCase() === 'entity name') {
            this.props.changeEntityView(name, currentValue, componentId);
            this.props.changeEntityForm(name, currentValue, componentId);
          } else if (name.toLowerCase() === 'views') {
            this.props.changeEntity(name, currentValue, componentId);
          } else if (name.toLowerCase() === 'layout view') {
            this.props.changeEntityViewColumn(currentValue);
          } else if (name.toLowerCase() === 'quick create form') {
            const entityName = store.getState().modalState.controlConfig.control.Properties.filter(x => x.Name === "Entity Name")[0].Value;
            ControlHelper.loadEntityForms(entityName);
            // this.props.changeFormFields(name, currentValue, componentId);
          } else if (name.toLowerCase() === 'quick edit form') {
            // const entityName = store.getState().modalState.controlConfig.control.Properties.filter(x => x.Name === "Entity Name")[0].Value;
            // ControlHelper.loadEntityForms(entityName);
            // this.props.changeFormFields(name, currentValue, componentId);
          }
        }
        else if (store.getState().modalState.controlConfig.control.ControlType.NameType === "Quick Create Form" ||
          store.getState().modalState.controlConfig.control.ControlType.NameType === "Create Form") {

          if (isQuickCreateProperty)
            this.props.changeFormFields(name, currentValue, componentId);
        }


        !isQuickCreateProperty && this.props.isLayoutPanel ?
          this.props.change(name, currentValue, componentId, this.props.layoutPanelIndex)
          :
          this.props.change(name, currentValue, componentId);

      }
      else if (store.getState().modalState.modal.openModal === EModalType.LoopConfig) {
        this.props.change(name, value, componentId)
      } else {
        this.props.change(name, value, componentId)
      }

      store.dispatch({
        type: types.SET_IS_PROPERTY_CHANGED,
        value: true
      });

    }, 500);

  }

  private getFormattedDate = (dateString: string): string => {
    let date = new Date(dateString);
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;
    let day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;
    return day + '/' + month + '/' + year + ' 00:00:00';
  }

  private extractDate = (dateString: string): Date => {
    let date = new Date();
    //the dateString will be in the format "dd/MM/yyyy hh:mm:ss"
    let splitDate = dateString.split(' ')[0].split('/');
    date.setFullYear(+splitDate[2], +splitDate[1] - 1, +splitDate[0]);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    return date;
  }

  private property = (property: IProperty, index: number): JSX.Element => {
    let { entityOptionSet, entityStateCode, statusReason, entityViews, entityForms,
      entityFormattedAttributes, entityViewColumns, outputOptions, fields, areEntityFormsLoading, areEntityViewsLoading } = this.props;
    let field: JSX.Element;
    let { Name, Value, ValueOptions, Default, IsRequired, Min, Max } = property;
    // let defaultOption: IDropdownOption[] = [{ text: 'Type to search an entity', key: '' }];
    let defaultOption: IDropdownOption[] = [];

    let value = (Value === null || Value === undefined) ? Default : Value;

    let propertyIsDisabled: boolean = this.props.controlType && this.props.useDefaults && PropertyHelper.isDefaultedProperty(this.props.controlType, Name);

    let adjustmentChanges = PropertyHelper.GetAdjustmentChanges(property, value, this.props.properties);

    let tabIndex = this.props.primaryOnly ? null : index + 2;

    if (adjustmentChanges.IsVisible && !property.IsHidden) {
      property.IsInvisible = false;

      switch (property.Type) {

        case EPropertyTypes.string:
          field = <TextField label={adjustmentChanges.Label || Name} value={value || ''} disabled={propertyIsDisabled}
            onChanged={(val) => this.debounceValue(Name, val, this.props.componentId)} required={IsRequired} tabIndex={tabIndex} />;
          break;

        case EPropertyTypes.boolean:
          field = <Toggle label={adjustmentChanges.Label || Name} checked={value} disabled={propertyIsDisabled}
            onChanged={(val) => this.debounceValue(Name, val, this.props.componentId)} required={IsRequired} tabIndex={tabIndex} />;
          break;

        case EPropertyTypes.number:
          field = <TextField label={adjustmentChanges.Label || Name} value={value.toString()} disabled={propertyIsDisabled}
            onChanged={(val) => this.debounceValue(Name, val, this.props.componentId)} required={IsRequired} tabIndex={tabIndex} />;
          break;

        case EPropertyTypes.decimal:
          field = <TextField label={Name} value={value.toString()} disabled={propertyIsDisabled}
            onChanged={(val) => this.debounceValue(Name, val, this.props.componentId)} required={IsRequired} tabIndex={tabIndex} />;
          break;

        case EPropertyTypes.dropdown:
          if (property.IsDependentDropdown) {
            let optionsValueLabel;

            switch (property.Name) {
              case 'State Code':
                optionsValueLabel = entityStateCode ? entityStateCode.map((element) => {
                  return {
                    value: element.key,
                    label: element.text
                  };
                }) : property.ValueOptions ? property.ValueOptions.map((element) => {
                  return {
                    value: element.key,
                    label: element.text
                  };
                }) : null;
                break;
              case 'Status Reason':
                optionsValueLabel = statusReason ? statusReason.map((element) => {
                  return {
                    value: element.key,
                    label: element.text
                  };
                }) : property.ValueOptions ? property.ValueOptions.map((element) => {
                  return {
                    value: element.key,
                    label: element.text
                  };
                }) : null;
                break;
              case 'Layout View':
              case 'Views':
                if (entityViews) {
                  optionsValueLabel = entityViews.map((element) => {
                    return {
                      value: element.key,
                      label: JSON.parse(element.text).name
                    };
                  })
                }
                else {
                  optionsValueLabel = property.ValueOptions ? property.ValueOptions.map((element) => {
                    return {
                      value: element.key,
                      label: element.text
                    };
                  }) : null;
                }
                break;
              case 'Quick Create Form':
              case 'Quick Edit Form':
                if (entityForms) {
                  optionsValueLabel = entityForms.map((element) => {
                    return {
                      value: element.key,
                      label: element.text
                    };
                  })
                }
                else {
                  optionsValueLabel = property.ValueOptions ? property.ValueOptions.map((element) => {
                    return {
                      value: element.key,
                      label: element.text
                    };
                  }) : null;
                }
                break;
              case 'View':
              case 'Views':
                if (entityViews) {
                  optionsValueLabel = entityViews.map((element) => {
                    return {
                      value: element.key,
                      label: element.text
                    };
                  })
                }
                else {
                  optionsValueLabel = property.ValueOptions ? property.ValueOptions.map((element) => {
                    return {
                      value: element.key,
                      label: element.text
                    };
                  }) : null;
                }
                break;
              case 'Column':
              case 'Hyperlink Column':
                Name = "Hyperlink Column";
                if (entityViewColumns && entityFormattedAttributes) {
                  optionsValueLabel = entityViewColumns.map((element) => {
                    return {
                      value: element.Name,
                      label: entityFormattedAttributes[element.Name] ? entityFormattedAttributes[element.Name] : element.Name
                    };
                  })
                }
                else {
                  optionsValueLabel = property.ValueOptions ? property.ValueOptions.map((element) => {
                    return {
                      value: element.key,
                      label: element.text
                    };
                  }) : null;
                }
                break;
              default:
                optionsValueLabel = entityOptionSet ? entityOptionSet.map((element) => {
                  return {
                    value: element.key,
                    label: element.text
                  };
                }) : property.ValueOptions ? property.ValueOptions.map((element) => {
                  return {
                    value: element.key,
                    label: element.text
                  };
                }) : null;
                break;

            }

            if (property.IsSearchable) {
              if ((property.Name === 'Quick Create Form' && areEntityFormsLoading) || (property.Name === 'Layout View' && areEntityViewsLoading)) {
                field = <div>
                  <Label required={IsRequired} className="ms-Label">{adjustmentChanges.Label || Name}:</Label>
                  <Spinner className="loading-fetch" type={SpinnerType.normal} />
                </div>
              } else {
                field = (
                  <div>
                    <Label required={IsRequired} className="ms-Label">{adjustmentChanges.Label || Name}:</Label>
                    <div className="flex">
                      <Select
                        autoFocus={true}
                        className="field-dropdown searchable-dropdown"
                        placeholder={null}
                        // labelKey={adjustmentChanges.Label || Name}
                        options={optionsValueLabel}
                        inputValue={(value || '').toString()}
                        value={(value || '').toString()}
                        isDisabled={propertyIsDisabled}
                        required={IsRequired}
                        tabIndex={tabIndex}
                        onChange={(val) => {
                          // property.Name === 'State Code' ? this.changeStatusReasonValue(val.value) : null;
                          this.debounceValue(Name, val.value, this.props.componentId);
                        }}
                        isSearchable // Enable search filter
                        scrollMenuIntoView={false}
                        clearable={false}
                        menuPlacement="auto"
                        valueRenderer={(selectedOption) => selectedOption.label}
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            borderBottom: '1px solid lightgray', // Customize the control style
                          }),
                          menuPortal: (provided) => ({
                            ...provided,
                            zIndex: 9999, // Ensure the menu appears above other elements
                          }),
                        }}

                      />
                      {
                        (property.Name === 'Hyperlink Column' || property.Name === 'Column' || property.Name === 'Quick Create Form' || property.Name === 'Quick Edit Form') ?
                          < button title={"Clear"} type="button" className="select-clear-btn" onClick={() => this.debounceValue(Name, '', this.props.componentId)}>
                            <i className="ms-Icon ms-Icon--ChromeClose" aria-hidden="true"></i>
                          </button>
                          : null
                      }
                    </div>
                  </div >
                )
              }
            } else {
              let options: IDropdownOption[];
              switch (property.Name) {
                case 'State Code':
                  options = defaultOption.concat(entityStateCode || adjustmentChanges.OptionValues || ValueOptions);
                  break;
                case 'Status Reason':
                  options = defaultOption.concat(statusReason || adjustmentChanges.OptionValues || ValueOptions);
                  break;
                default:
                  options = defaultOption.concat(adjustmentChanges.OptionValues || ValueOptions);
                  break;
              }

              field = <DropdownTabbed options={options} label={adjustmentChanges.Label || Name} selectedKey={(value || '').toString()} disabled={propertyIsDisabled}
                required={IsRequired} tabIndex={tabIndex}
                onChanged={(val) => {
                  property.Name === 'State Code' ? this.changeStatusReasonValue(val.key.toString()) : null;
                  this.debounceValue(Name, val.key, this.props.componentId)
                }}
              />;

            }
          }

          else if (property.Name === 'Filter Datapoints By') {
            let caseServiceTypes = store.getState().modalState.controlConfig.caseServiceTypes;
            let caseServiceTypesValueOptions: IDropdownOption[] = [];
            const test = ValueOptions;

            if (Object.keys(caseServiceTypes).length) {
              Object.keys(caseServiceTypes).forEach(element => {
                let option: IDropdownOption = {
                  key: element,
                  text: caseServiceTypes[element]
                };
                caseServiceTypesValueOptions = caseServiceTypesValueOptions.concat(option);
              });
            }

            let options: IDropdownOption[] = defaultOption.concat(adjustmentChanges.OptionValues || caseServiceTypesValueOptions);
            field = <DropdownTabbed options={options} label={adjustmentChanges.Label || Name} selectedKey={(value || '').toString()} disabled={propertyIsDisabled}
              required={IsRequired} tabIndex={tabIndex}
              onChanged={(val) => {
                property.Name === 'State Code' ? this.changeStatusReasonValue(val.key.toString()) : null;
                this.debounceValue(Name, val.key, this.props.componentId)
              }}
            />;

            // let optionsValueLabel;
            // ControlHelper.loadCaseServiceTypes()
            //   .then(entityFields => {
            //     optionsValueLabel = entityFields ? entityFields.map((element) => {
            //       return {
            //         value: element.key,
            //         label: element.text
            //       };
            //     }) : property.ValueOptions ? property.ValueOptions.map((element) => {
            //       return {
            //         value: element.key,
            //         label: element.text
            //       };
            //     }) : null;

            //     field = <DropdownTabbed options={optionsValueLabel} label={adjustmentChanges.Label || Name} selectedKey={(value || '').toString()} disabled={propertyIsDisabled}
            //       required={IsRequired} tabIndex={tabIndex}
            //       onChanged={(val) => {
            //         property.Name === 'State Code' ? this.changeStatusReasonValue(val.key.toString()) : null;
            //         this.debounceValue(Name, val.key, this.props.componentId)
            //       }}
            //     />;

            //   });

          }
          else {

            let options = defaultOption.concat(adjustmentChanges.OptionValues || ValueOptions);
            if (property.IsSearchable) {
              const optionsValueLabel = options[0] !== null && options.map((element) => {
                return {
                  value: element.key,
                  label: element.text
                };
              });

              field = (
                <div>
                  <Label required={IsRequired} className="ms-Label">{adjustmentChanges.Label || Name}:</Label>
                  <div className="flex">
                    <Select
                      id={"field-dropdown-" + property.Id}
                      autoFocus={true}
                      className="field-dropdown searchable-dropdown"
                      placeholder={null}
                      // labelKey={adjustmentChanges.Label || Name}
                      options={optionsValueLabel}
                      inputValue={(value || '').toString()}
                      value={(value || '').toString()}
                      isDisabled={propertyIsDisabled}
                      required={IsRequired}
                      tabIndex={tabIndex}
                      onChange={(val) => {
                        property.IsDependentDropdownSource ? this.changeDropdownSourceValue(val.value) : null;
                        this.debounceValue(Name, val.value, this.props.componentId);

                        // remove focus from the input
                        const id = "field-dropdown-" + property.Id;
                        document.getElementById(id).blur();
                      }}
                      isSearchable // Enable search filter
                      scrollMenuIntoView={false}
                      clearable={false}
                      menuPlacement="auto"
                      valueRenderer={(selectedOption) => selectedOption.label}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          borderBottom: '1px solid lightgray', // Customize the control style
                        }),
                        menuPortal: (provided) => ({
                          ...provided,
                          zIndex: 9999, // Ensure the menu appears above other elements
                        }),
                      }}
                    />
                    {
                      (property.Name === 'Hyperlink Column' || property.Name === 'Column' || property.Name === 'Quick Create Form') ?
                        <button title={"Clear"} type="button" className="select-clear-btn" onClick={() => this.debounceValue(Name, null, this.props.componentId)}>
                          <i className="ms-Icon ms-Icon--ChromeClose" aria-hidden="true"></i>
                        </button>
                        : null
                    }
                  </div>

                </div>
              )

            } else {

              let options: IDropdownOption[] = defaultOption.concat(adjustmentChanges.OptionValues || ValueOptions);

              if (this.props.filteredValueOptions && this.props.filteredValueOptions[property.Id]) {
                let filteredValueOptions = this.props.filteredValueOptions[property.Id];
                options = options.filter(o => {
                  return o.key === defaultOption[0].key || filteredValueOptions.some(fvo => fvo.key === o.key);
                });
              }
              field = <DropdownTabbed options={options} label={adjustmentChanges.Label || Name} selectedKey={(value || '').toString()} disabled={propertyIsDisabled}
                required={true} tabIndex={tabIndex}
                onChanged={(val) => this.debounceValue(Name, val.key, this.props.componentId)} />;

            }
          }
          break;

        case EPropertyTypes.dateTime:
          field = (
            <div tabIndex={tabIndex}>
              <DatePicker strings={DayPickerStrings} label={adjustmentChanges.Label || Name} value={value && value.length ? this.extractDate(value) : null} isRequired={IsRequired}
                onSelectDate={(val) => this.debounceValue(Name, val ? this.getFormattedDate(val.toString()) : null, this.props.componentId)} />
            </div>
          );
          break;

        case EPropertyTypes.listOfOptions:
          field = null;
          break;

        case EPropertyTypes.url:
          field = <TextField label={adjustmentChanges.Label || Name} value={value || ''} required={IsRequired} disabled={propertyIsDisabled}
            onChanged={(val) => this.debounceValue(Name, val, this.props.componentId)} tabIndex={tabIndex} />;
          break;

        case EPropertyTypes.input:
          field = <DropdownTabbed options={ValueOptions} label={adjustmentChanges.Label || Name} selectedKey={value} disabled={propertyIsDisabled}
            tabIndex={tabIndex} required={IsRequired} onChanged={(val) => this.debounceValue(Name, val.key, this.props.componentId)} />;
          break;

        case EPropertyTypes.dynamic:

          field = <ContentEditableTinyMCE
            label={adjustmentChanges.Label || Name}
            value={value}
            outputOptions={this.props.outputOptions || []}
            singleLine={!Properties.multilineDynamicProperties[Name] && !property.IsRichText && !property.IsMultiline}
            richText={property.IsRichText}
            onBlur={
              (val) => {
                if (store.getState().modalState.modal.openModal === EModalType.ActionConfig && store.getState().modalState.actionConfig.action.ActionType.NameType === "Get Records") {
                  var entityNameProp = store.getState().modalState.actionConfig.action.Properties.filter(x => x.Name === "Entity Name")[0];
                  var viewsProp = store.getState().modalState.actionConfig.action.Properties.filter(x => x.Name === "Views")[0];
                  var fetchXMLProp = store.getState().modalState.actionConfig.action.Properties.filter(x => x.Name === "Fetch XML")[0];

                  if (ComponentHelper.getEditorText(val)) {
                    entityNameProp.Value ?
                      entityNameProp.IsRequired = true
                      : entityNameProp.IsRequired = false;
                    viewsProp.Value ?
                      viewsProp.IsRequired = true
                      : viewsProp.IsRequired = false;
                    fetchXMLProp.IsRequired = true;
                    this.props.change(Name, val, this.props.componentId);
                  } else {
                    entityNameProp.IsRequired = true;
                    viewsProp.IsRequired = true;
                    entityNameProp.Value ?
                      fetchXMLProp.IsRequired = false
                      : null;

                  }
                }
                else if (store.getState().modalState.modal.openModal === EModalType.ControlConfig && property.IsQuickCreateProperty) {
                  this.props.updateFormField(this.props.formId, property.Id, property.Name, val);
                }
                else if (store.getState().modalState.modal.openModal === EModalType.ActionConfig && store.getState().modalState.actionConfig.action.ActionType.NameType === "Get Record") {
                  // Add outputs from FetchXML
                  if (val && JSON.parse(val).text) {
                    const fetchXMLLinkAttributes = PropertyHelper.extractLinkEntityAttributes(JSON.parse(val).text);
                    const fetchXMLOutputs: IOutput[] = fetchXMLLinkAttributes.map(x => {
                      return {
                        Id: IdHelper.newGuid(),
                        componentId: this.props.componentId,
                        FriendlyName: x,
                        Name: x,
                        Type: 0,
                        ValueType: 0,
                        GlobalOutputId: '',
                        LogicalName: x,
                        IsRequiredGlobalOutput: false,
                        DisablePrepopulatedValue: false,
                        OutputScope: EOutputScope.Local,
                        IsHidden: false,
                        IsImmutable: true,
                        StaticName: x,
                      }
                    })
                    store.dispatch({
                      type: types.SET_FETCHXML_OUTPUTS,
                      outputs: fetchXMLOutputs
                    });
                  }
                  this.props.change(Name, val, this.props.componentId);
                } else {
                  this.props.change(Name, val, this.props.componentId);
                }
              }
            }
            tabIndex={tabIndex}
            required={IsRequired}
            readonly={propertyIsDisabled}
            outputLookupContext={EOutputLookupContext.NotSpecified}
          />;

          break;

        case EPropertyTypes.query:
          field = <QueryBuilder
            queryBuilderConfig={value ? JSON.parse(value) : null}
            label={property.Name}
            propertyOptions={this.props.outputOptions || []}
            id={property.Id}
            outputLookupContext={property.Name === VISIBILITY_EXPRESSION_PROPERTY_NAME ? EOutputLookupContext.VisibilityExpressionConfig : EOutputLookupContext.NotSpecified}
            onChange={(queryBuilderConfig: IConditionConfig) => {
              this.debounceValue(Name, JSON.stringify(queryBuilderConfig), this.props.componentId);
            }}
          />;
          break;

        case EPropertyTypes.entityFilterQuery:
          let propertyOptions;
          if (fields && fields.length) {
            propertyOptions = fields.map((element, index) => {
              if (element.FriendlyName && element.FieldName)
                return {
                  index: index,
                  key: element.FieldName,
                  text: element.FriendlyName
                };
            })
          }

          field = <ViewFilterQueryBuilder
            queryBuilderConfig={value ? JSON.parse(value) : null}
            label={property.Name}
            propertyOptions={propertyOptions ? propertyOptions : []}
            id={property.Id}
            outputLookupContext={property.Name === VISIBILITY_EXPRESSION_PROPERTY_NAME ? EOutputLookupContext.VisibilityExpressionConfig : EOutputLookupContext.VisibilityExpressionConfig}
            onChange={(queryBuilderConfig: IConditionConfig) => {
              this.debounceValue(Name, JSON.stringify(queryBuilderConfig), this.props.componentId);
            }}
          />;
          break;

        case EPropertyTypes.time:
          let hours: string = value.split(':')[0];
          let minutes: string = value.split(':')[1];
          field = (
            <div className={IsRequired ? 'required-field' : ''}>
              <label className="ms-Label">{adjustmentChanges.Label || Name}</label>
              <div className="ms-Grid">
                <div className="ms-Grid-row grid-no-padding">
                  <div className="ms-Grid-col ms-u-sm6">
                    <DropdownTabbed tabIndex={tabIndex} required={IsRequired} disabled={propertyIsDisabled} options={HOURS} label={'Hours'}
                      selectedKey={hours} onChanged={(val) => this.debounceValue(Name, val.key + ':' + minutes, this.props.componentId)} />
                  </div>
                  <div className="ms-Grid-col ms-u-sm6">
                    <DropdownTabbed tabIndex={tabIndex} required={IsRequired} disabled={propertyIsDisabled} options={MINUTES} label={'Minutes'}
                      selectedKey={minutes} onChanged={(val) => this.debounceValue(Name, hours + ':' + val.key, this.props.componentId)} />
                  </div>
                </div>
              </div>
            </div>
          );
          break;

        case EPropertyTypes.wholeNumber:
          field = (
            <Slider label={adjustmentChanges.Label || Name} min={Min} max={Max} defaultValue={Default} showValue={true} value={value}
              disabled={propertyIsDisabled}
              onChange={(val) => this.debounceValue(Name, val, this.props.componentId)} />
          );
          break;

        case EPropertyTypes.checkboxList:
          field = (
            <CheckboxList
              id={property.Id}
              label={adjustmentChanges.Label || Name}
              options={ValueOptions}
              value={value || Default}
              onChange={(val) => this.props.change(Name, val, this.props.componentId)}
              required={property.IsRequired}
            />
          );
          break;

      }
    }
    else {
      property.IsInvisible = true;
    }

    let tooltipElement = property.Tooltip && property.Tooltip.length ? <i className="ms-Icon ms-Icon--Info x-hidden-focus property-tooltip"
      title={property.Tooltip} aria-hidden="true" data-toggle="tooltip" data-placement="right" data-html="true">
    </i> : null;

    let item: JSX.Element = field ? <div key={'prop_' + Name} className={'property-wrapper' + (property.Tooltip && property.Tooltip.length ? ' has-tooltip' : '')}>
      {tooltipElement}{field}
      {
        Name && (Name.toLowerCase().indexOf("icon") > -1) ?
          <span className="property-info"> <i> Please add an icon class from <a href="https://fontawesome.com/v4/icons" target="_blank">here</a>. Example: <b>fa-home</b></i>
          </span>
          :
          null
      }
    </div> : null;
    return item;

  }

  public componentDidUpdate() {

    DOMHelper.setDropdownPropertyTabIndex();
    if (!this.props.primaryOnly && this.firstUpdate) {
      this.firstUpdate = !DOMHelper.focusOnFirstModalTabbableControl();
    }

    // move the tooltip to next to the label 
    jQuery('.property-wrapper > .property-tooltip').each((i, elem) => {
      jQuery(elem).closest('.property-wrapper').find('.ms-Label').after(jQuery(elem));
    });
    jQuery('.property-tooltip').tooltip();

  }

  private propertyIsExcluded = (propertyName: string): boolean => {
    return this.props.propertiesToExclude ? this.props.propertiesToExclude.filter(p => p === propertyName).length > 0 : false;
  }

  public render() {
    let { properties, isLoading, areEntityFormsLoading, primaryOnly, propertiesToExclude, entityOptionSet, showOnlyVisibility } = this.props;
    let items: JSX.Element[] = [];
    let entityNameProperty = properties.filter(x => x.Name === 'Entity Name');
    this.entityName = entityNameProperty.length ? entityNameProperty[0].Value : null;

    // filter properties
    // if (showOnlyVisibility) {
    //   properties = properties.filter(x => x.Type === EPropertyTypes.query);
    // } else {
    //   properties = properties.filter(x => x.Type !== EPropertyTypes.query);
    // }
    if (showOnlyVisibility) {
      properties = properties.filter(x => x.Name === 'Visibility Expression');
    } else {
      properties = properties.filter(x => x.Name !== 'Visibility Expression');
    }

    if (properties && properties.length) {
      items = properties
        .filter(property => !this.propertyIsExcluded(property.Name) && (primaryOnly ? property.IsPrimary : true))
        .map(this.property);
    }

    // const areEntityFormsLoading: boolean = store.getState().modalState.controlConfig.areEntityFormsLoading;
    return <div className="properties-wrapper">
      {
        items
      }
    </div>;
  }

}



// WEBPACK FOOTER //
// ./source/ts/components/common/properties.tsx